/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { Box, Card, Container, Scrollable, Stack, Text } from '@mybridge/ui';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { MyTestimonials } from 'v4/snippets/profile/testimonials';
import {
  MyTestimonialsContext,
  useMyTestiomonialsContext,
} from 'v4/snippets/profile/testimonials/context';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import styles from '../../../snippets/profile/public/banner/banner.module.scss'
import { isMobile } from 'react-device-detect';
import { HStack, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { myBridgeData } from 'v4/components/header/status-dropdown/constant';

const Profile = () => {
  const ctx = useMyTestiomonialsContext({});
  const [randomThreeMessages, setRandomThreeMessages] = useState([]);


  useEffect(() => {
    function getRandomThree(arr) {
      const shuffled = arr.sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 3);
    }

    // Initialize with three random messages on mount
    setRandomThreeMessages(getRandomThree(myBridgeData));
  }, []);
  return (
    <AuthenticatedProviders>
      <MyTestimonialsContext.Provider value={ctx}>
      <Container maxW="100vw" p={[0, 4]}>
        <HStack
          flexDir={['column', 'column', 'row']}
          alignItems="flex-start"
          justifyContent="center"
          w="100%"
          backgroundColor="rgb(255, 255, 255)"
        >
          {!isMobile && (
            <Stack
              display={['none', 'none', 'flex']}
              className={styles.left}
              pos="sticky"
              top="64px"
              spacing={2}
              borderBottom="1px solid #e0e0e094"
              height={'500px'}
              sx={{

                '@media (max-width: 1301px)': {
                  width: '80px',
                },
                '@media (max-width: 1182px)': {
                  width: '85px',
                },
              }}
            >
              <Stack
                spacing={2}
                justifyContent="space-between"
                height="100%"
                align="stretch"
                h="calc(100vh - 0px)"
                backgroundColor="rgb(255, 255, 255)"
              >
                <Stack spacing={2} align="stretch" h="100%" flex="1">
                  <SiteShortcutLinks />

                  <Box className={styles.Network}>
                    <DashboardMyCircle h="300px" flex="1" />
                  </Box>
                </Stack>
                {/* <ImportContacts /> */}
                {/* <MainCopyrightsText /> */}
              </Stack>
            </Stack>
          )}

          <Stack className={styles.mainContent} pt={3}>
            <MyTestimonials />
          </Stack>
        </HStack>
      </Container>
      </MyTestimonialsContext.Provider>
    </AuthenticatedProviders>
  );
};

export default Profile;
